/* eslint-disable */
export default (theme) => ({
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  paper: {
    "-webkit-box-shadow": "0px 0px 7px 0px rgba(50, 50, 50, 0.64)",
    "-moz-box-shadow": "0px 0px 7px 0px rgba(50, 50, 50, 0.64)",
    "box-shadow": "0px 0px 7px 0px rgba(50, 50, 50, 0.64)",
  },
  numberTextField: {
    "&input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});
